import React from 'react';
import { Grid } from '@mui/material';
import { ReactSession } from 'react-client-session';
import { useHistory } from 'react-router-dom';
import accountStyles from '../styles';
import LoginOtp from '../../../components/LoginOtp';
import analytics from '../../../utils/analytics';

function LoginOtpForm() {
  const classes = accountStyles();
  const history = useHistory();

  const handleSuccess = (session: { token: string }) => {
    ReactSession.setStoreType('sessionStorage');
    ReactSession.set('token', session.token);
    analytics.track('Inicio sesión', { method: 'otp' });
    setTimeout(() => history.push('/account'), 1000);
  };

  return (
    <Grid
      container
      className={classes.root}
      justifyContent="center"
      alignItems="center"
    >
      <LoginOtp onSuccess={handleSuccess} />
    </Grid>
  );
}

export default LoginOtpForm;
